//src/i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
// 准备翻译的语言环境信息
const messages = {
	'zh-CN': {
		message: {
			i18n_1: '查询',
			i18n_2: '输入评级编号',
			i18n_3: '北京公博古钱币艺术品鉴定有限公司',
			i18n_4: '全国服务热线',
			i18n_5: '联系人',
			i18n_6: '电话',
			i18n_7: '邮箱',
			i18n_8: '地址',
			i18n_9: '送评收货地址',
			i18n_10: '企业公众号',
			i18n_11: '企业客服微信',
			i18n_12: 'Copyright 北京公博古钱币艺术品鉴定有限公司 All Rights Reserved',
			i18n_13: '京ICP备14004369号-1',
			i18n_13_1: '邮箱',
			i18n_13_2: 'gbcadev@aliyun.com',
			i18n_14: '技术支持',
			i18n_14_1: '济南汉驰信息技术有限公司',
			i18n_15: '首页',
			i18n_16: '导航栏目',
			i18n_17: '关于我们',
			i18n_18: '了解更多',
			i18n_19: '请选择省份',
			i18n_20: '请选择市',
			i18n_21: '请选择区',
			i18n_22: '姓名或电话',
			i18n_23: '共‘xxx’条',
			i18n_24: '下载',
			i18n_25: '鉴定查询',
			i18n_26: '查询历史',
			i18n_27: '请输入评级编号',
			i18n_28: '输入编号进行查询',
			i18n_29: '如遇到查询上的问题返回，请点击',
			i18n_30: '暂无图片',
			// i18n_31: '原币退回',
			i18n_31: '赝品（counterfeit）',
			i18n_32: '不适合评级包装',
			i18n_33: '详细',
			i18n_34: '查看详情',
			i18n_35: '未找到评级单信息',
			i18n_36: '此评级信息由',
			i18n_36_1: '此图片信息仅供参考，不因展示承担法律责任，公博评级币的持币人（包括送评人和买受人）均受GBCA服务协议约束！ ',
			i18n_2026_327: '该单位对本品评级信息及评级服务事宜承担责任。',
			i18n_37: '客服电话',
			i18n_38: '本公司监制单位：北京中国书画收藏家协会文物鉴定委员会 缩写文物鉴定委员会',
			i18n_39: '交流换藏欢迎咨询推荐平台',
			i18n_40: '请选择版式',
			i18n_41: '免责声明',
			i18n_42: '钱币赏析',
			i18n_43: '客户反馈',
			i18n_44: '您的反馈是',
			i18n_45: '请选择',
			i18n_46: '反馈内容',
			i18n_47: '请输入要反馈的内容',
			i18n_48: '图片',
			i18n_49: '点击上传',
			i18n_50: '预览',
			i18n_51: '提交',
			i18n_52: '重写',
			i18n_53: '提交成功',
			i18n_54: '提交失败',
			i18n_55: '信息未填写完整',
			i18n_56: '发票申请',
			i18n_57: '送评手机号',
			i18n_58: '请输入送评手机号',
			i18n_59: '送评单号',
			i18n_60: '请输入送评单号',
			i18n_61: '发票类型',
			i18n_62: '请选择发票类型：',
			i18n_63: '普通发票',
			i18n_64: '专用发票',
			i18n_65: '发票抬头',
			i18n_65_1: '抬头类型',
			i18n_65_2: '单位税号',
			i18n_65_3: '注册地址',
			i18n_65_4: '注册电话',
			i18n_65_5: '开户行',
			i18n_65_6: '银行账号',
			i18n_66: '请选择发票抬头',
			i18n_67: '个人',
			i18n_68: '单位',
			i18n_69: '发票内容',
			i18n_69_1: '鉴定服务',
			i18n_70: '收票人手机号',
			i18n_70_1: '收票人姓名',
			i18n_71: '收票人地区',
			i18n_72: '详细地址',
			i18n_73: '总金额',
			i18n_74: '全国代理',
			i18n_75: '省份',
			i18n_76: '城市',
			i18n_77: '地区',
			i18n_78: '姓名',
			i18n_79: '电话',
			i18n_80: '收货地址',
			i18n_81: '备注',
			i18n_82: '暂无结果',
			i18n_83: '暂时没有查询到该钱币的鉴定信息',
			i18n_84: '如有疑问请咨询官方客服',
			i18n_85: '该标签已经通过公博NFC技术验证',
			i18n_86: '注意：该标签未通过公博NFC技术验证',
			i18n_87: '全国代理',
			i18n_88: '统计范围',
			i18n_89: '导航菜单',
			i18n_90: '海外代理',
			i18n_91: '主体',
			language: "语言"
		}
	},
	en: {
		message: {
			i18n_1: 'Search',
			i18n_2: 'Serial number',
			i18n_3: 'BEIJING GONGBO COINS Appraisal Co., Ltd.',
			i18n_4: 'Hotline',
			i18n_5: 'Contact',
			i18n_6: 'Contact Number',
			i18n_7: 'E-mail Address',
			i18n_8: 'Address',
			i18n_9: 'Shipping Address',
			i18n_10: 'Official WeChat Account',
			i18n_11: 'Official Customer Service',
			i18n_12: 'Copyright BEIJING GONGBO COINS Appraisal Co. Ltd. All Rights Reserved',
			i18n_13: 'ICP of China, BeiJing number：14004369-1',
			i18n_13_1: 'MAILBOX',
			i18n_13_2: 'gbcadev@aliyun.com',
			i18n_14: 'TECHNICAL SUPPORT',
			i18n_14_1: 'Qingdao SHOUCANGQUAN Network Technology Co., Ltd',
			i18n_15: 'HOME',
			i18n_16: 'NAVIGATION',
			i18n_17: 'ABOUT US',
			i18n_18: 'Learn More',
			i18n_19: 'Please select a province',
			i18n_20: 'Please select a city',
			i18n_21: 'Please select an area',
			i18n_22: 'Name or Contact number',
			i18n_23: "xxx' PIECES OF DATA IN TOTAL",
			i18n_24: 'Download',
			i18n_25: 'Appraisal query',
			i18n_26: 'Search History',
			i18n_27: 'Please Enter the Serial Number',
			i18n_28: 'Enter the Number to Query',
			i18n_29: 'If you encounter a problem in the query, please click',
			i18n_30: 'No Picture',
			// i18n_31: 'FORGE',
			i18n_31: 'Counterfeit',
			i18n_32: 'Not suitable for grading packaging',
			i18n_33: 'Detailed',
			i18n_34: 'View Details',
			i18n_35: 'INFORMATION NOT AVAILABLE',
			i18n_36: 'The Grading Information is Provided by ',
			i18n_36_1: ' The Picture Information is for Reference only. No Legal Risk for Display',
			i18n_2026_327: 'The unit is responsible for the rating information and rating services of this product.',
			i18n_37: 'Customer Service Numbers',
			i18n_38: 'Supervised by:Chinese Painting and Calligraphy Collectors Association-Cultural Relics Appraisal Committee（CRAC)',
			i18n_39: 'Trading Platform',
			i18n_40: 'Please select Pattern',
			i18n_41: 'Disclaimer',
			i18n_42: 'Appreciation of coins',
			i18n_43: 'Feedback',
			i18n_44: 'Your feedback',
			i18n_45: 'Please select',
			i18n_46: 'Content',
			i18n_47: 'Please enter the content to be fed back',
			i18n_48: 'Picture',
			i18n_49: 'Click Upload',
			i18n_50: 'Preview',
			i18n_51: 'Submit',
			i18n_52: 'Rewrite',
			i18n_53: 'Submitted successfully',
			i18n_54: 'Submit failed',
			i18n_55: 'Incomplete information',
			i18n_56: 'Invoice application',
			i18n_57: 'Applicant telephone',
			i18n_58: 'Fill in the telephone',
			i18n_59: 'Order number',
			i18n_60: 'Fill in the order number',
			i18n_61: 'Invoice type',
			i18n_62: 'Please select invoice type',
			i18n_63: 'Ordinary invoice',
			i18n_64: 'Special invoice',
			i18n_65: 'Invoice header',
			i18n_65_1: 'Header type',
			i18n_65_2: 'Tax ID Number',
			i18n_65_3: 'Address',
			i18n_65_4: 'Tel',
			i18n_65_5: 'Account with Bank',
			i18n_65_6: 'Account Number',
			i18n_66: 'Please select invoice header',
			i18n_67: 'Personal',
			i18n_68: 'Enterprise/Organization',
			i18n_69: 'Invoice content',
			i18n_69_1: 'Appraisal service',
			i18n_70: "Receiver's mobile number",
			i18n_70_1: "Receiver's name",
			i18n_71: 'Recipient area',
			i18n_72: 'Detailed address',
			i18n_73: 'Total amount',
			i18n_74: 'AGENT',
			i18n_75: 'Province',
			i18n_76: 'City',
			i18n_77: 'Area',
			i18n_78: 'Name',
			i18n_79: 'Contact Number',
			i18n_80: 'Shipping Address',
			i18n_81: 'Note',
			i18n_82: 'No results',
			i18n_83: 'There is no identification information for the coin at this time',
			i18n_84: 'If you have any questions, please contact customer service',
			i18n_85: 'The tag has been verified by Gongbo NFC technology',
			i18n_86: 'Note: The tag has not been verified by the Gongbo NFC technology',
			i18n_87: 'Domestic Agent',
			i18n_88: 'Updated',
			i18n_89: 'MENU',
			language: "Language",
			i18n_90: 'Overseas Agency',
			i18n_91: 'Subject',
		}
	},
}

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
	locale: localStorage.getItem('language') || ((navigator.language == 'zh-CN' || navigator.language == 'en') ? navigator.language : 'zh-CN'), // 设置地区
	messages // 设置地区信息
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js